import React from 'react'

const ManuallyQuestion = () => {
  return (
    <div>ManuallyQuestion123</div>
  )
}

export default ManuallyQuestion;